const selectServiceType = {
  serviceType: 'Serviço:',
  department: 'Departamento:',
  brand: 'Marca:',
  description: 'Descrição:',
  place: 'Local:',
  reference: 'Ponto de referência:',
  serviceTypeTitle: 'Tipo de serviço',
  onTime: 'Em dia',
  overdue: 'Em atraso',
  noService: 'Sem serviço',
  mandatory: 'Serviço mandatório',
  expiration: 'Vencimento:',
  daysRemaining: 'dias restantes',
  daysOverdue: 'dias em atraso',
  dayRemaining: 'dia restante',
  dayOverdue: 'dia em atraso',
  buttonGoBack: 'voltar',
  lastPerform: 'Última inspeção:',
  onDemand: 'Serviço sob demanda'
};

export default selectServiceType;